import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { showAlert } from "../../../utils/Helpers";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import DivLoader from "../Loader/DivLoader";
import "../../../pages/style.css";
import "../../../pages/responsive.css";
import { handleEncrypt, getLanguage } from "../../../utils/HelperFunctions";
import { encryptUserId, decryptUserId } from "../../../utils/cryptoUtils";

const ChangePasswordPage = ({
  handleChangepasswordclose,
  setShowSaveConfirmation,
  Email,
  setEmail,
}) => {
  const { t } = useTranslation();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");

  const [loader, setloader] = useState("");

  const handleOldPasswordToggle = () => {
    setOldPasswordType(oldPasswordType === "password" ? "text" : "password");
  };

  const handleNewPasswordToggle = () => {
    setNewPasswordType(newPasswordType === "password" ? "text" : "password");
  };

  const handleConfirmPasswordToggle = () => {
    setConfirmPasswordType(
      confirmPasswordType === "password" ? "text" : "password"
    );
  };

  const handleSaveSuccessfulSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (oldPassword.length === 0) {
      validationErrors.oldPassword = t("requiredField");
    }
    if (newPassword.length === 0) {
      validationErrors.newPassword = t("requiredField");
    }
    if (confirmPassword.length === 0) {
      validationErrors.confirmPassword = t("requiredField");
    }
    if (Object.keys(validationErrors).length === 0) {
      if (newPassword.length < 8) {
        validationErrors.newPassword = t("passwordTooShort");
      }
      if (!/(?=.*[!@#$%^&*(),.?":{}|<>])(?=.{8,})/.test(newPassword)) {
        validationErrors.newPassword = t("passwordValidation2");
      }
      if (newPassword !== confirmPassword) {
        validationErrors.confirmPassword = t("passwordsDoNotMatch");
      }
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    //const NewPassword = await handleEncrypt(newPassword);
    const encryptedEmail = encryptUserId(Email);
    const encryptedoldPassword = encryptUserId(oldPassword);    
    const encryptedNewPassword = encryptUserId(newPassword);

    Email = encryptedEmail;
    let OldPassword = encryptedoldPassword;
    let NewPassword = encryptedNewPassword;


    try {
      setloader(true);
      const response = await fetch(
        //`${process.env.REACT_APP_API_URL}/Auth/change-password`,
        `${process.env.REACT_APP_API_URL}/Auth/change-passwordforweb`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": getLanguage(),
          },
          //body: JSON.stringify({ Email, oldPassword, newPassword }),
          body: JSON.stringify({ Email, OldPassword, NewPassword }),
        }
      );

      if (!response.ok) {
        let data = await response.json();
        setloader(false);
        showAlert(data.message, "error");
        setErrorMessage(data.message);
        setTimeout(() => setErrorMessage(""), 3000);
        return;
      }
      await response.json();
      handleChangepasswordclose(true);
      setloader(false);
      setShowSaveConfirmation(true);
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        showAlert(t("networkError"), "error");
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
        setloader(false);
      } else {
        showAlert(error.message, "error");
        setErrorMessage(t("networkError"));
        setloader(false);
        setTimeout(() => setErrorMessage(""), 3000);
      }
    }
  };

  return (
    <div className="signup-modal h-100">
      <div className="container mt-5">
        <div className="row justify-content-center">

          <form className="signup-form">
            <div className="row gy-3 gy-md-4 overflow-hidden">

              <div className="col-12 mt-2 mb-2 position-relative">

                <input
                  type={oldPasswordType}
                  className="form-control"
                  name="oldPassword"
                  id="oldPassword"
                  placeholder="Old Password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
                <label
                  className="eye-icon-position1"
                  onClick={handleOldPasswordToggle}
                >
                  {oldPasswordType === "text" ? (
                    <FaEyeSlash size={22} />
                  ) : (
                    <FaEye size={22} />
                  )}
                </label>
                {errors.oldPassword && (
                  <div className="text-danger">{errors.oldPassword}</div>
                )}
              </div>
              <div className="col-12 mt-2 mb-2 position-relative">

                <input
                  type={newPasswordType}
                  className="form-control"
                  name="new_password"
                  id="newPassword"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <label
                  className="eye-icon-position1"
                  onClick={handleNewPasswordToggle}
                >
                  {newPasswordType === "text" ? (
                    <FaEyeSlash size={22} />
                  ) : (
                    <FaEye size={22} />
                  )}
                </label>
                {errors.newPassword && (
                  <div className="text-danger">{errors.newPassword}</div>
                )}
              </div>
              <div className="col-12 mt-2 mb-2 position-relative">

                <input
                  type={confirmPasswordType}
                  className="form-control"
                  name="confirm_password"
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <label
                  className="eye-icon-position1"
                  onClick={handleConfirmPasswordToggle}
                >
                  {confirmPasswordType === "text" ? (
                    <FaEyeSlash size={22} />
                  ) : (
                    <FaEye size={22} />
                  )}
                </label>
                {errors.confirmPassword && (
                  <div className="text-danger">{errors.confirmPassword}</div>
                )}
              </div>
              <div className="btn-container myinfo-btn mt-4 ">
                <button
                  className="btn btn-outline Lr-3"
                  type="button"
                  onClick={handleChangepasswordclose}
                >
                  {t("cancel")}
                </button>
                <button
                  className="btn btn-primary lg-signin-btn "
                  type="submit"
                  onClick={handleSaveSuccessfulSubmit}
                >
                  {t("UpdateButton")}
                </button>
              </div>
              {errorMessage && (
                <div className="error-message" style={{ color: "red" }}>
                  {errorMessage}
                </div>
              )}
            </div>
          </form>
          {loader && <DivLoader></DivLoader>}
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
